module.exports = __webpack_public_path__ + "static/media/teacher_logo.98a527bd.svg";